import psl from './vendor/parse-domain';

import Ga from './analytic/Ga.vue'
import Gtm from './analytic/Gtm.vue'

let Vue = require('vue')
let VueCookies =  require('vue3-cookies')
const { cookies } = VueCookies.useCookies()

const App = {
    components: {
        ga: Ga,
        gtm: Gtm
    },
    data() {
        return {
            showCookieBar: true,
            showSettings: false,
            acceptExpire: '1d',
            rejectExpire: '1d',
            enableCookiePerformance: false,
            cookiePerformance: false,
        }
    },
    mounted() {

        this.showCookieBar = cookies.isKey('cookie-policy') ? false : true;

        this.init();
    },

    methods: {

        init()
        {
            this.acceptExpire = cookieSetting['accept'];
            this.rejectExpire = cookieSetting['reject'];

            this.cookiePerformance = this.getCookiePerformance();
            this.enableCookiePerformance = this.cookiePerformance;

            if(this.cookiePerformance && !cookies.isKey('cookie-policy'))
            {
                cookies.set('cookie-performance', true, this.acceptExpire);
            }
        },

        getCookiePerformance()
        {
            if(cookies.isKey('cookie-performance')){

                return cookies.get('cookie-performance')

            } else {

                return cookieSetting['cookie-performance']
            }
        },

        toggleSetting()
        {
            this.showSettings = !this.showSettings;
        },

        toggleCookiePerformance()
        {
            this.enableCookiePerformance = !this.enableCookiePerformance;
        },

        acceptCookie(value)
        {
            this.enableCookiePerformance = true;
            this.onSave(this.acceptExpire);
        },

        rejectCookie()
        {

            this.enableCookiePerformance = false;
            this.onSave(this.rejectExpire);
        },

        onSave(expire)
        {

            this.showSettings = false;
            this.showCookieBar = false;
            if(typeof expire == undefined || expire == '') {
                expire = this.acceptExpire;
            }

            // define 3rd party cookies
            this.cookiePerformance = this.enableCookiePerformance;
            if(this.cookiePerformance)
            {
                cookies.set('cookie-performance', true, this.acceptExpire);
            } else {
                this.removeAnalyticCookies();
            }

            // necessary cookies
            cookies.set('cookie-policy', true, expire)
        },

        removeAnalyticCookies()
        {
            let domain = window.location.hostname;
            domain = psl.parse(domain).domain;

            let getCookies = cookies.keys();

            for(const key of getCookies) {
                // remove associate piwik
                if(key.includes('_pk')) {
                    cookies.remove(key);
                }
                // remove associate google
                if(key.includes('_g')) {
                    cookies.remove(key, '/', domain);
                }
            }

            cookies.remove('cookie-performance');
        }

    },

  }

  Vue.createApp(App).mount('#cookie')
